import { combineReducers } from 'redux-immutable'

import reportReducer from './Report/reducers'
import portfolioReducer from './Portfolio/reducers'

const rootReducer = combineReducers({
    report: reportReducer,
    portfolio: portfolioReducer,
})

export default rootReducer
